module.exports = "/assets/data/354ae3f8e9f5062057f32e1177d7432b-GL15.data.json";